module.exports = __webpack_public_path__ + "static/media/nav-earth.5e6bd3a7.svg";